import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import numeral from 'numeral';
import CollapsibleDisclaimer from 'Components/ComponentLibrary/Components/Uncategorized/CollapsibleDisclaimer';
import AreaChart from 'Components/ComponentLibrary/Components/Uncategorized/AreaChart';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

export const InvestmentReturnsSectionForScenarioSelectionModelUpdate = ({
  modelPerformanceData,
  modelPerformanceChartData,
}) => {
  const isMobile = useMobileLayout();
  const [modelPerformanceDataResource] = modelPerformanceData;

  const data = modelPerformanceChartData.resources().list().map(resource => {
    const attributes = resource.attributes();
    return { ...attributes, value: Number(attributes.value) };
  });

  const formatNumber = (value) => {
    return `$${numeral(value).format('0a')}`;
  };

  if (!modelPerformanceDataResource) return null;

  return (
    <FDStack direction={'column'} spacing={3}>
      <FDBodyText value={'This section shows you the historical performance of this model. Keep in mind that past performance is not indicative of future results.'} />
      <FDStack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 2 : 6}>
        <AreaChart
          width={isMobile ? '100%' : '50%'}
          data={data}
          height={150}
          xDataKey={'date'}
          yTicks={[100000, 300000]}
          xTicks={['2005', '2010', '2015', '2020']}
          yTickFormatFn={formatNumber}
        />
        <FDStack direction={'column'} spacing={1} width={isMobile ? '100%' : '50%'}>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <FDBodyText value={'Starting Balance'} />
            <FDBodyText value={modelPerformanceDataResource.attr('startingBalance')} />
          </FDStack>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <FDBodyText value={'Ending Balance'} />
            <FDBodyText value={modelPerformanceDataResource.attr('endingBalance')} />
          </FDStack>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <FDBodyText value={'Total Return ($)'} />
            <FDBodyText value={modelPerformanceDataResource.attr('totalReturn')} />
          </FDStack>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <FDBodyText value={'Total Return (%)'} />
            <FDBodyText value={modelPerformanceDataResource.attr('totalReturnPercent')} />
          </FDStack>
          <FDStack direction={'row'} justifyContent={'space-between'}>
            <FDBodyText value={'Average Annual Return'} />
            <FDBodyText value={modelPerformanceDataResource.attr('averageAnnualReturn')} />
          </FDStack>
        </FDStack>
      </FDStack>
      <CollapsibleDisclaimer
        disclaimerTitle={'Hypothetical Investment Disclaimer'}
        disclaimerText={modelPerformanceDataResource.attr('investmentReturnsDisclaimer')}
        disclaimerReadMore={modelPerformanceDataResource.attr('investmentReturnsDisclaimerReadMore')}
      />
    </FDStack>
  );
};
InvestmentReturnsSectionForScenarioSelectionModelUpdate.propTypes = {
  modelPerformanceData: PropTypes.instanceOf(fr.Collection).isRequired,
  modelPerformanceChartData: PropTypes.instanceOf(fr.Collection).isRequired,
};
